import types from '../../constants';
import auth from '../../auth';
import history from '../../history';

export function validate(navigate) {
  return async(dispatch) => {
    dispatch({
      type: types.VALIDATE_START,
    });
    return fetch('/api/valid', {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          dispatch({
            type: types.VALIDATE_FAILED,
          });
          navigate('/login');
          // history.push('/login');
          throw new Error('Not authenticated.');
        }

        dispatch({
          type: types.VALIDATE_END,
          payload: true,
        });
      })
      .catch(err => console.log(err)); // eslint-disable-line

    return true;
  };

}
